import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getReportsStagesProgress: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_STAGES_PROGRESS].GET_REPORTS_STAGES_PROGRESS,
	},
}
